"use client";

import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import "./WhatsAppBtn.css";

export default function FloatingButtons() {
  return (
    <div className="floating-buttons">

      {/* Call Button */}
      <a
        href="tel:+91 88808 28698"
        className="call-float"
        aria-label="Call Now"
      >
        <FaPhoneAlt size={20} color="#fff" style={{marginTop:"-5px"}}/>
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/8880828698"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={26} color="#fff" />
      </a>

    </div>
  );
}